import React, { useCallback, useEffect, useMemo, useState } from 'react';
import type { NextPage } from 'next';
import styles from './styles.module.scss';
import axios from 'axios';
import { PageLayout } from '@/components/pagelay';
import { Table, TreeSelect } from '@douyinfe/semi-ui';
import classNames from 'classnames';
import { Pagina } from '@/components/pagination';
import { useRouter } from 'next/router';
import { getServerSideProps, getHead } from '@/utils/useHead';
import useRequest from '@/utils/useRequest';
import { useTranslations } from 'next-intl';

interface IProps {

}
export { getServerSideProps }

const Product: NextPage<IProps> = ({ navDetail }: any) => {
  const router = useRouter()
  const [active, setActive] = useState(0)
  const [data, setData] = useState<any>({})
  const request = useRequest()
  const t = useTranslations();
  const getData = useCallback(async (id: any) => {
    const { data } = await request.get(`/getProduct`, {
      params: {
        id
      }
    })
    setData(data.data)
    window.scrollTo(0, 0)
  }, [router.query, router.locale])

  const toDetail = useCallback((id: string) => {
    const lang = router.locale === 'cn' ? '' : '/en'
    const fullPath = window.location.origin + lang + `/online/product/info?id=${id}`;
    window.open(fullPath, '_blank');
  }, [router.locale])

  useEffect(() => {
    const { id } = router.query;
    getData(id)
  }, [router.query, router.locale])

  return (
    <div>
      <PageLayout
        temp='page_crumb'
        crumb={[
          {
            path: router.locale === 'cn' ? router.asPath : '/en' + router.asPath,
            name: data?.[`title_${router.locale}`]
          }
        ]}
        partPath='/online/product'
      >
        <div className={styles.container}>
          {getHead(navDetail)}
          <i className={styles.bg1}></i>
          <div className={styles.top}>
            <div className={styles.left}>
              <div className={styles.image}>
                <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} loading='lazy' src={data?.images?.[active]} alt="" />
              </div>
              <div className={styles.imgList}>
                {
                  data?.images?.map((item: any, index: number) => (
                    item && <div
                      className={classNames({
                        [styles.imgItem]: true,
                        [styles.active]: active === index
                      })}
                      key={index}
                      onClick={() => setActive(index)}
                    >
                      <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} loading='lazy' src={item} alt="" />
                    </div>
                  ))
                }
              </div>
            </div>
            <div className={styles.right}>
              <div className={styles.title}>
                <h2>{data.name}</h2>
                <p>{data.company}</p>
                <div>
                  <p className={styles.venues}>{t('online.booth')}{router.locale == 'en' && <>&nbsp;</>}{data.booth_num}</p>
                  <p className={styles.cate}>{data.category_name}</p>
                </div>
              </div>
              <h3>{t('online.intro')}</h3>
              <div className={styles.intro} dangerouslySetInnerHTML={{ __html: data.content }} />
              {/* <h3>相关产品</h3>
              <div className={styles.relation}>
                {
                  data.related_product_list?.map((item: any) => (
                    <div className={styles.item} key={item.id} onClick={() => toDetail(item.id)}>
                      <div className={styles.image}>
                        <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} loading='lazy' src={item.image} alt="" />
                      </div>
                      <div className={styles.detail}>
                        <h4>{item.name}</h4>
                        <p>{item.category_name}</p>
                      </div>
                    </div>
                  ))
                }
              </div> */}
            </div>
          </div>
          <div className={styles.bottom}>
            <h3>{t('online.other')}</h3>
            <div className={styles.others}>
              {
                data.other_product_list?.map((item: any) => (
                  <div className={styles.item} key={item.id} onClick={() => toDetail(item.id)}>
                    <div className={styles.image}>
                      <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} loading='lazy' src={item.image} alt="" />
                    </div>
                    <div className={styles.detail}>
                      <h4>{item.name}</h4>
                      <p>{item.category_name}</p>
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </PageLayout>
    </div>
  );
};

export default Product;
